 $(document).ready(function(){  
    $(".tidio-chat-link").click(function(){
      var iframeChat = $("#tidio-chat-iframe");
      if(iframeChat){
        $("#tidio-chat-iframe").contents().find("#button-body").trigger('click');
        
      }
      return false;
    });

     var ddData = [
    {
        text: "United States",
        value: "https://shotkam.com/products/shotkam-gen-4",
        selected: false,
        description: "",
        imageSrc: "//cdn.shopify.com/s/files/1/1226/7384/files/usa-flag1_1024x1024.png"
    },
    {
        text: "Australia",
        value: "https://au.shotkam.com/products/shotkam-gen-4",
        selected: false,
        description: "",
        imageSrc: "//cdn.shopify.com/s/files/1/1226/7384/files/au-flag1_1024x1024.png"
    },
    {
        text: "Canada",
        value: "https://ca.shotkam.com/products/shotkam-gen-4",
        selected: false,
        description: "",
        imageSrc: "//cdn.shopify.com/s/files/1/1226/7384/files/canada-flag1_1024x1024.png"
    },
    {
        text: "Europe",
        value: "https://eu.shotkam.com/products/shotkam-gen-4",
        selected: true,
        description: "",
        imageSrc: "//cdn.shopify.com/s/files/1/1226/7384/files/eu-flag1_1024x1024.png"
    },
    {
        text: "United Kingdom",
        value: "https://uk.shotkam.com/products/shotkam-gen-4",
        selected: false,
        description: "",
        imageSrc: "//cdn.shopify.com/s/files/1/1226/7384/files/uk-flag1_1024x1024.png"
    }
];
      $('#countryDropDown2').ddslick({
    data:ddData,
    selectText: "",
    imagePosition:"left"
});
    
  });
  var actCallback = function (response) {
    $('#contactFormSubmit').prop("disabled", false);
   // $('#re-captcha').remove();
  };
  var expCallback = function() {
    $('#contactFormSubmit').prop("disabled", true);
  };
  
  var onloadCallback = function () {
    var widget = grecaptcha.render(document.getElementById("re-captcha"), {
      'sitekey' : "6LdAobEgAAAAAFcJFrHBb7gGPjvvJkkI1mzQvCLF",
      'theme': "light",
      'callback' : actCallback,
      'expired-callback': expCallback,
    });
  };

  $(document).ready (function() {
    $('#hotspotImg-1 .hot-spot').each(function(){
      $(this).hotSpot({
         bindselector: 'click'
      });
    });	
  });


/* Cart Page JS */
$(document).ready(function(){  
    $(".cart__product-qty").change(function(){
      $("#updateCartBtn").trigger("click");
    });

   
    
  }); 

 $(document).ready(function(){  
      if( $(window).width() >= 768 && $(window).width() <= 1292) {
      if (window.matchMedia("(orientation: portrait)").matches) {
        $('.acc-slides').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3
        });
      }
      if (window.matchMedia("(orientation: landscape)").matches) {
        $('.acc-slides').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots:true
        });
      }
    }else if( /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) ) {
      if (window.matchMedia("(orientation: portrait)").matches) {
        $('.acc-slides').slick({
          infinite: false,
          slidesToShow: 1,
          slidesToScroll: 1
        });
      }
      if (window.matchMedia("(orientation: landscape)").matches) {
        $('.acc-slides').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          dots:true
        });
      }
    }else{
      $('.acc-slides').slick({
        infinite: false,
        slidesToShow: 5,
        slidesToScroll: 5,
        dots:true
      });
    }
    
  }); 
  
    $(window).on('orientationchange', function(e){
    if(window.orientation == 0) {
      $('.acc-slides').slick('unslick');
      if( /iPad/i.test(navigator.userAgent) ) {
        $('.acc-slides').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3
        });
      }else{
      $('.acc-slides').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll:1
      });
      }
    } else {
      if( /iPad/i.test(navigator.userAgent) ) {
        $('.acc-slides').slick({
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3
        });
      }else{
      $('.acc-slides').slick('unslick');
      $('.acc-slides').slick({
        infinite: false,
        slidesToShow: 3,
        slidesToScroll: 3
      });
      }
    }
  });
  $(document).ready(function(){
    $(".cartAccessories").on("submit", function(evt) {
      var data = {};
      var $form = $(evt.target);
      var arr = $form.serializeArray(); // an array of all form items
      for (var i=0; i<arr.length; i++) { // transforming the array to object
        data[arr[i].name] = arr[i].value;
      }
      data.return_type = "json"; // optional identifier - you can handle it on server and respond with JSON instead of HTML output
      $.ajax({
        url: $form.attr('action') || document.URL, // server script from form action attribute or document URL (if action is empty or not specified)
        type: $form.attr('method') || 'get', // method by form method or GET if not specified
        dataType: 'json', // we expect JSON in response
        data: data // object with all form items
      }).done(function(respond) {
        console.log("data handled on server - response:", respond);
        $('body').trigger('added.ajaxProduct');
        if($("#checkoutDrawer").hasClass("hide")){
          $("#checkoutDrawer").removeClass("hide");
        }

      }).fail(function(){
        alert("Server connection failed!");
      });

      return false; // suppress default submit action
    }); 

    
  });


  function removeItem(obj){
    var itemKey = $(obj).data('key');
        var item1 = '.cart_updates_'+itemKey;
        $(item1).val(0);
     	$('.cart_updates_'+itemKey).trigger("change");
  }
$(document).ready(function() {

$('.hot-spot').click(function(){
 $('.hot-spot').removeClass('active');
  $(this).addClass('active');
  var lnk=$(this).attr('link');
  
  $('.abt--hotspot').removeClass('active')
  $('.abt--hotspot#'+lnk).addClass('active');
  if($(window).width() < 992 ){
   var indxs= $(this).index();
     $('.cstmslider').slickGoTo(indxs);
  }
})
  $('.abt--hotspot').click(function(){
     $('.hot-spot').removeClass('active');
    $('.abt--hotspot').removeClass('active');
    $(this).addClass('active');
  
   var id= $(this).attr('id');
    $('.hot-spot').each(function(){
      var that=this
      var gtid=$(that).attr('link');
      if(gtid==id){
        $(that).addClass('active');
      }
    })
  })
  $('.topsection-header ul li').click(function(){
    
    if($(this).hasClass('active')){}else{
     
      $('.topsection-header ul li').removeClass('active');
      $(this).addClass('active')
      var trget=$(this).attr('trget');
      $('.product--details-area .switcher__product').hide();
       $('.product--details-area .switcher__product.'+trget).show();
      $('.hot-spot').removeClass('active')
      $('.hot-spot.htspt1').addClass('active')
      $('.abt--hotspot').removeClass('active')
      $('div#trigger1.abt--hotspot').addClass('active')
      
      setTimeout(function(){
        
        $('.cstmslider').slickGoTo(0);
      },200)
    }
  })
 
 $('.cstmslider').slick({
 centerMode: false,
  slidesToShow: 2,
   slidesToScroll: 2,
   infinite:false,
   arrows:true
});

  $("#hotspotImg-1").click(function(){
    window.location.href="/products/shotkam-gen-4";
  });
 $("#hotspotImg-2").click(function(){
    window.location.href="/products/shotkam";
  });
  
});

  $(document).ready(function(){
   /* $("#SiteHeader ul li.site-nav__item a[href='/products/shotkam']").click(function(event){
      event.preventDefault();
      $(".product--megaMenu").slideToggle("slow");
      $("body").removeClass("unloading");
    }); */
    $(".camera-link").click(function(event){
      event.preventDefault();
      $(".product--megaMenu").slideToggle('fast');
      $("body").toggleClass('open--mega')
      $("body").removeClass("unloading");
      if($("body").hasClass("open--mega")){
        if($("#signup_banner").length > 0){
          $("#signup_banner").hide();
        }
      }
      if(!$("body").hasClass("open--mega")){
        if($("#signup_banner").length > 0){
          $("#signup_banner").show();
        }
      }
      
      return false;
    });
   // document.addEventListener("scroll", function(){$(".product--megaMenu").hide();$("body").removeClass('open--mega'); });
     $(window).scroll(function(){
      $mainMenuBarAnchor = $('#SiteHeader');
      var $window = $(window);
      var window_top = $window.scrollTop();
        var div_top = $mainMenuBarAnchor.offset().top;
        if (window_top > 0) {
        $('#SiteHeader').addClass('stickheadertoggling');
        $(".learnmorestickybar").show();
       $("#signup_banner").hide();
      }
      else{
      $('#SiteHeader').removeClass('stickheadertoggling');
        $(".learnmorestickybar").hide();
        $("#signup_banner").show();
      }
        /*if (window_top == 0) {
          $("body.shotkam-products .product--megaMenu").show();$("body.shotkam-products").addClass('open--mega');
        }
       if (window_top >= 5) {
          $("body.shotkam-products .product--megaMenu").hide();$("body.shotkam-products").removeClass('open--mega'); 
        }*/
    });
   //toggling learnmore menu
   $(".learnmorebtn").click(function(e){
     e.preventDefault();
     $(this).parent('li').find("ul").toggle();
     $(".hideme").toggleClass("reverseIcon");
     
   });

    $(".template-index").find(".pwImage").click(function(){
      var pLink = $(this).data("link");
      window.location.href = pLink;
    });
  });

/* SWIPE EFFECT */
/*(function($) {
  $.fn.swipeDetector = function(options) {
    var swipeState = 0;
    var startX = 0;
    var startY = 0;
    var pixelOffsetX = 0;
    var pixelOffsetY = 0;
    var swipeTarget = this;
    var defaultSettings = {
      swipeThreshold: 70,
      useOnlyTouch: false
    };

    (function init() {
      options = $.extend(defaultSettings, options);
      swipeTarget.on("mousedown touchstart", swipeStart);
      $("html").on("mouseup touchend", swipeEnd);
      $("html").on("mousemove touchmove", swiping);
    })();

    function swipeStart(event) {
      if (options.useOnlyTouch && !event.originalEvent.touches) return;

      if (event.originalEvent.touches) event = event.originalEvent.touches[0];

      if (swipeState === 0) {
        swipeState = 1;
        startX = event.clientX;
        startY = event.clientY;
      }
    }

    function swipeEnd(event) {
      if (swipeState === 2) {
        swipeState = 0;

        if (
          Math.abs(pixelOffsetX) > Math.abs(pixelOffsetY) &&
          Math.abs(pixelOffsetX) > options.swipeThreshold
        ) {

          if (pixelOffsetX < 0) {
            swipeTarget.trigger($.Event("swipeLeft.sd"));

          } else {
            swipeTarget.trigger($.Event("swipeRight.sd"));

          }
        } else if (Math.abs(pixelOffsetY) > options.swipeThreshold) {

          if (pixelOffsetY < 0) {
            swipeTarget.trigger($.Event("swipeUp.sd"));

          } else {
            swipeTarget.trigger($.Event("swipeDown.sd"));
           
          }
        }
      }
    }

    function swiping(event) {
      if (swipeState !== 1) return;

      if (event.originalEvent.touches) {
        event = event.originalEvent.touches[0];
      }

      var swipeOffsetX = event.clientX - startX;
      var swipeOffsetY = event.clientY - startY;

      if (
        Math.abs(swipeOffsetX) > options.swipeThreshold ||
        Math.abs(swipeOffsetY) > options.swipeThreshold
      ) {
        swipeState = 2;
        pixelOffsetX = swipeOffsetX;
        pixelOffsetY = swipeOffsetY;
      }
    }

    return swipeTarget; 
  };
})(jQuery); 

$("document").ready(function() {
     $(".product-swritcher-1")
    .swipeDetector()
    .on("swipeLeft.sd swipeRight.sd", function(event) {
      if (event.type === "swipeLeft") {
        $(".swritcher-2").trigger("click");
      }
    });
  $(".product-swritcher-2")
    .swipeDetector()
    .on("swipeRight.sd swipeLeft.sd", function(event) {
    if (event.type === "swipeRight") {
        $(".swritcher-1").trigger("click");
      }
    });
     $(".hImg-1")
    .swipeDetector()
    .on("swipeLeft.sd swipeRight.sd", function(event) {
      if (event.type === "swipeLeft") {
        $(".swritcher-2").trigger("click");
      }
      
    });
   $(".hImg-2")
    .swipeDetector()
    .on("swipeRight.sd swipeLeft.sd", function(event) {
     if (event.type === "swipeRight") {
        $(".swritcher-1").trigger("click");
      }
    });
});  */

function showTimer(date,element){
  /*var countDownDate = new Date(date).getTime();

  // Update the count down every 1 second
  var x = setInterval(function() {

    // Get today's date and time
    var offset = -300; //Timezone offset for EST in minutes.
    var now = new Date().getTime();

    // Find the distance between now and the count down date
    var distance = countDownDate - now;

    // Time calculations for days, hours, minutes and seconds
    var days = Math.floor(distance / (1000 * 60 * 60 * 24));
    var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    var seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // Display the result in the element with id="demo"
     var days1 = (days <= 0) ? "" :  days + " Days ";
   document.getElementById(element).innerHTML = "<span>"+days1+ hours + " Hours "
    + minutes + " Mins " + seconds + " Sec</span>";
    // If the count down is finished, write some text
    if (distance < 0) {
      clearInterval(x);
    }
  }, 1000);*/
}
